import type { ProductType, SectionType } from '~/utils/api/common';

export const useCommonStore = defineStore('common', () => {
  const config = useRuntimeConfig();
  const userStore = useUserStore();

  const products = ref<ProductType[]>([]);
  const sections = ref<SectionType[]>([]);
  const isTestGroup = ref(config.public.isTestGroup);

  const fetchCommon = async () => {
    const data = await CommonAPI.common();
    products.value = data.products;
    sections.value = data.sections;
    isTestGroup.value = data.isTestGroup || config.public.isTestGroup;

    return { products: products.value, sections: sections.value };
  };

  watch(
    () => userStore.authorized,
    (_, prev) => {
      if (import.meta.client && prev !== undefined) fetchCommon();
    },
  );

  return {
    products,
    sections,
    isTestGroup,

    fetchCommon,
  };
});
